// Third party packages
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
// Custom packages
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
var SearchDocsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function SearchDocsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    SearchDocsService.prototype.getSearchDocs = function (search, properties) {
        var _this = this;
        var params = { search: search };
        if (Array.isArray(properties)) {
            Object.keys(properties).forEach(function (key) {
                var newParamKey = "properties[" + key + "]";
                var newParamValue = properties[key].id;
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService
            .apiCall("GET", "document-archives/search-docs", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Search docs of all condoStructure
     *
     * @since 1.0.0
     *
     * @param
     */
    SearchDocsService.prototype.getSearchDocsGeneral = function (search, data) {
        var _this = this;
        var params = { search: search };
        var area = data ? data.area : undefined;
        var properties = data ? data.properties : undefined;
        var company = data ? data.company : undefined;
        var topic = data ? data.topic : undefined;
        var subTopics = data ? data.subTopics : undefined;
        var documents = data ? data.documents : undefined;
        var supplier = data ? data.supplier : undefined;
        var startDate = data ? data.startDate : undefined;
        var endDate = data ? data.endDate : undefined;
        var protocollo = data ? data.protocollo : undefined;
        var keyword = data ? data.keyword : undefined;
        // Single field params
        if (area) {
            params['area'] = area;
        }
        if (topic) {
            params['topic'] = topic;
        }
        if (supplier) {
            params['supplier'] = supplier;
        }
        if (startDate) {
            params['startDate'] = startDate;
        }
        if (endDate) {
            params['endDate'] = endDate;
        }
        if (company) {
            params['company'] = company;
        }
        if (protocollo) {
            params['protocollo'] = protocollo;
        }
        if (keyword) {
            params['keyword'] = keyword;
        }
        // Array params
        if (Array.isArray(properties)) {
            if (properties.length && properties[0] === "all") {
                var newParamKey = "properties[0]";
                var newParamValue = "all";
                params[newParamKey] = newParamValue;
            }
            else {
                Object.keys(properties).forEach(function (key) {
                    var newParamKey = "properties[" + key + "]";
                    var newParamValue = properties[key].id;
                    params[newParamKey] = newParamValue;
                });
            }
        }
        if (Array.isArray(subTopics)) {
            Object.keys(subTopics).forEach(function (key) {
                var newParamKey = "subTopics[" + key + "]";
                var newParamValue = subTopics[key].rawTitle;
                params[newParamKey] = newParamValue;
            });
        }
        if (Array.isArray(documents)) {
            Object.keys(documents).forEach(function (key) {
                var newParamKey = "documents[" + key + "]";
                var newParamValue = documents[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService
            .apiCall("GET", "document-archives/search-docs-general", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    SearchDocsService.prototype.getSearchDocsGeneralV2 = function (data) {
        var _this = this;
        var params = {};
        var area = data ? data.area : undefined;
        var properties = data ? data.properties : undefined;
        var company = data ? data.company : undefined;
        var topic = data ? data.topic : undefined;
        var subTopics = data ? data.subTopics : undefined;
        var documents = data ? data.documents : undefined;
        var supplier = data ? data.supplier : undefined;
        var startDate = data ? data.startDate : undefined;
        var endDate = data ? data.endDate : undefined;
        var protocollo = data ? data.protocollo : undefined;
        var keyword = data ? data.keyword : undefined;
        if (area) {
            params['area'] = area;
        }
        if (topic) {
            params['topic'] = topic;
        }
        if (supplier) {
            params['supplier'] = supplier;
        }
        if (startDate) {
            params['startDate'] = startDate;
        }
        if (endDate) {
            params['endDate'] = endDate;
        }
        if (company) {
            params['company'] = company;
        }
        if (protocollo) {
            params['protocollo'] = protocollo;
        }
        if (keyword) {
            params['keyword'] = keyword;
        }
        if (Array.isArray(subTopics)) {
            Object.keys(subTopics).forEach(function (key) {
                var newParamKey = "subTopics[" + key + "]";
                var newParamValue = subTopics[key];
                params[newParamKey] = newParamValue;
            });
        }
        if (Array.isArray(documents)) {
            Object.keys(documents).forEach(function (key) {
                var newParamKey = "documents[" + key + "]";
                var newParamValue = documents[key];
                params[newParamKey] = newParamValue;
            });
        }
        if (Array.isArray(properties)) {
            Object.keys(properties).forEach(function (key) {
                var newParamKey = "properties[" + key + "]";
                var newParamValue = properties[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService
            .apiCall("GET", "document-archives/search-docs-general", params)
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Get all properties
     *
     * @since 1.0.0
     *
     * @param
     */
    SearchDocsService.prototype.getSearchDocsProperties = function (companyId) {
        var _this = this;
        if (companyId) {
            return this.apiService
                .apiCall("GET", "properties/get-all/" + companyId)
                .pipe(catchError(function (err) {
                _this.helperService.handleError(err);
                return throwError(err);
            }));
        }
        return this.apiService
            .apiCall("GET", "properties/get-all")
            .pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    SearchDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SearchDocsService_Factory() { return new SearchDocsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: SearchDocsService, providedIn: "root" });
    return SearchDocsService;
}());
export { SearchDocsService };
